import Image from "next/image";
import Link from "next/link";
import useTranslation from "next-translate/useTranslation";

const ProfileAndDashboard = () => {
  const { t } = useTranslation("become-consultant");

  return (
    <section className="container lg:py-16">
      <div className="flex flex-col items-start justify-between gap-4 lg:flex-row lg:gap-20">
        <div className="relative shrink-0">
          <Image src="/become-consultant/profile-dashboard.png" alt="Profile And Dashboard" width={661} height={587} />
          <div className="absolute top-9 -right-4 hidden translate-x-full lg:block">
            <div className="relative">
              <div className="absolute top-1/2 -left-2 -translate-y-1/2 border-y-4 border-r-8 border-solid border-y-transparent border-r-grey-300" />
              <div className="inline-block rounded-lg bg-grey-300 py-3.5 px-5 text-xs font-semibold">
                {t`profile-and-dashboard.your-user-account`}
              </div>
            </div>
          </div>
          <div className="absolute right-32 bottom-40 hidden lg:block">
            <div className="relative">
              <div className="absolute top-1/2 -left-2 -translate-y-1/2 border-y-4 border-r-8 border-solid border-y-transparent border-r-grey-300" />
              <div className="inline-block rounded-lg bg-grey-300 py-3.5 px-5 text-xs font-semibold">
                {t`profile-and-dashboard.your-profile`}
              </div>
            </div>
          </div>
        </div>
        <div className="mt-10 md:mt-16 lg:mt-24 xl:mt-32">
          <h2 className="text-center text-xl font-semibold lg:text-left lg:text-4xl">{t`profile-and-dashboard.title`}</h2>
          <p className="mt-3 text-center text-xs text-grey-700 lg:text-left lg:text-base">
            {t`profile-and-dashboard.description`}
          </p>
          <Link href="/register/start" passHref>
            <button type="button" className="button-lg hover-orange mx-auto mt-5 block lg:mx-0 lg:mt-12">
              {t`start-now`}
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProfileAndDashboard;
